import { render, staticRenderFns } from "./DiagnosisNavigator.vue?vue&type=template&id=46ebb230&scoped=true"
import script from "./DiagnosisNavigator.vue?vue&type=script&lang=js"
export * from "./DiagnosisNavigator.vue?vue&type=script&lang=js"
import style0 from "./DiagnosisNavigator.vue?vue&type=style&index=0&id=46ebb230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ebb230",
  null
  
)

export default component.exports